import { filterProjects } from 'common/api/v1/projects';

import {
    FETCH_FILTER_PROJECTS,
    FETCH_FILTER_PROJECTS_FAILURE,
    FETCH_FILTER_PROJECTS_SUCCESS,
    SHOW_EMPTY_STATE,
} from '../actionTypes';
import { projectsActions } from '../reducer';

export default ({
        contactId,
        orderBy,
        page,
        pageSize,
        projectStatus,
        searchText,
        sortBy,
        status,
    } = {}) =>
    (dispatch) => {
        dispatch(projectsActions[FETCH_FILTER_PROJECTS]());
        dispatch(
            projectsActions[SHOW_EMPTY_STATE]({
                status,
                show: false,
            }),
        );

        filterProjects({
            contactId,
            orderBy,
            page: page + 1,
            perPage: pageSize,
            projectStatus,
            searchText,
            sortBy,
            status,
        })
            .then((response) => {
                dispatch(
                    projectsActions[FETCH_FILTER_PROJECTS_SUCCESS](
                        response.data,
                    ),
                );
                dispatch(
                    projectsActions[SHOW_EMPTY_STATE]({
                        status,
                        show: response?.data?.data?.length === 0 || false,
                    }),
                );
            })
            .catch((error) =>
                dispatch(
                    projectsActions[FETCH_FILTER_PROJECTS_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            );
    };
